import CrudSection from "../components/CrudSection";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import LeadsLive from "./LeadsLive";
import FuentesLive from "./FuentesLive";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Leads sub-sections — part of the unified "Contactos y Leads" module.
// "Bandeja de leads" reads real leads from the API (landing contact form →
// CRM) and "Fuentes" aggregates those same leads by origin. "Calificación" is
// still a mock scaffold (lead scoring) to be wired up. The combined dashboard
// now lives in contactos.tsx (ContactosLeadsDashboard).
// ===========================================================================

// Live inbox (real data) — re-exported under the section's name.
export const LeadsInbox = LeadsLive;

// Live sources (real data) — leads aggregated by origin.
export const FuentesSection = FuentesLive;

// --- Reglas de calificación (mock) -----------------------------------------
interface Regla extends Record<string, unknown> {
  id: string; nombre: string; condicion: string; puntos: string; estado: string;
}
const reglaColumns: CrudColumn<Regla>[] = [
  { key: "nombre", label: "Regla" },
  { key: "condicion", label: "Condición" },
  { key: "puntos", label: "Puntos" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const reglaFields: CrudField[] = [
  { key: "nombre", label: "Nombre", required: true, placeholder: "Empresa grande" },
  { key: "condicion", label: "Condición", required: true, placeholder: "Tamaño de empresa > 200" },
  { key: "puntos", label: "Puntos", type: "number", placeholder: "10" },
  { key: "estado", label: "Estado", type: "select", defaultValue: "Activo", options: [
    { value: "Activo", label: "Activo" }, { value: "Inactivo", label: "Inactivo" },
  ] },
];
const reglaSeed: Regla[] = [
  { id: "rg1", nombre: "Empresa grande", condicion: "Tamaño > 200 empleados", puntos: "20", estado: "Activo" },
  { id: "rg2", nombre: "Solicita demo", condicion: "Método de contacto = Llamada", puntos: "15", estado: "Activo" },
  { id: "rg3", nombre: "Correo corporativo", condicion: "Email no es gratuito", puntos: "10", estado: "Activo" },
];
export const CalificacionSection = () => (
  <CrudSection<Regla> title="Reglas de calificación" subtitle="Lead scoring automático"
    icon="ri-medal-line" columns={reglaColumns} fields={reglaFields} seed={reglaSeed} searchKey="nombre" />
);
